<rpshared-save-bar
	[title]="title$ | async"
	[isSaving]="isSaving$ | async"
	[isFormInvalid]="invalidSubmission$ | async"
	(save)="save($event)"
></rpshared-save-bar>

<div [formGroup]="form" gdGap="10px" class="with-fixed-sub-toolbar">
	<div fxLayout.gt-md="row" fxLayout.lt-lg="column" fxFlexAlign="stretch" fxLayoutGap="8px">
		<div fxFlex.gt-md="65%" fxLayout="column" fxLayoutGap="8px">
			<mat-card fxFlex>
				<div class="list-loading-shade list-loading-shade-detail-card" *ngIf="isLoading$ | async">
					<mat-progress-bar mode="indeterminate" class="mat-card-loading"></mat-progress-bar>
				</div>
				<rpshared-card-title icon="train" title="General Information"></rpshared-card-title>
				<rpfsa-personnel-general-info
					(selectPayrollType)="payrollTypeSelected($event)"
					(fieldWorkerTypeSelected)="fieldWorkerTypeSelected($event)"
					gdColumns="repeat(auto-fill, minmax(250px, 1fr))"
					gdGap="10px"
					formControlName="generalInfo"
				></rpfsa-personnel-general-info>
			</mat-card>
		</div>
		<div fxFlex.gt-md="35%" fxLayout="row" fxLayoutGap="8px">
			<mat-card fxFlex>
				<rpshared-card-title icon="history" title="History"></rpshared-card-title>
				<rpfsa-audit-trail-list 
					[isLoading]="isHistoryLoading$ | async" 
					[listMessage]="historyListMessage$ | async"
					[auditTrails]="history$ | async" paginatorLayoutAlign="start center">
				</rpfsa-audit-trail-list>
			</mat-card>
		</div>
	</div>
	
	<rpshared-mat-loading-card
		*ngIf="is1099Employee$ | async"
		[isLoading]="isLoading$ | async"
		icon="business"
		title="Pay as 1099 - Company Information"
	>
		<rpfsa-company-1099
			fxLayout="column"
			formControlName="company"
		></rpfsa-company-1099>
	</rpshared-mat-loading-card>

	<rpshared-mat-loading-card
		*ngIf="!(isNewRecord$ | async) && !(isFieldSupport$ | async)"
		[isLoading]="isLoading$ | async"
		icon="business"
		title="Unavailable Days"
	>
		<rpshared-unavailable-day-list
			[fieldWorkerId]="id$ | async"
			formControlName="unavailableDays"
		>
		</rpshared-unavailable-day-list>
	</rpshared-mat-loading-card>

	<mat-card>
		<rpshared-card-title
			icon="business"
			title="Job Assignments"
		></rpshared-card-title>
		<rpfsa-job-assignments-list
			[jobAssignments]="jobAssignments$ | async"
		></rpfsa-job-assignments-list>
	</mat-card>
</div>
